import { Button, Typography, Box, useMediaQuery } from "@mui/material";
import vivupLogo from "../../../assets/images/vivup-logo.png";
import useUserEvent from "../../../hooks/useUserEvent";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import useStepper from "../../../hooks/useStepper";
import { useNavigate } from "react-router-dom";

const StaffBenefitsButton = ({ trackingDetails }) => {
  const { userTrackingMutation } = useUserEvent();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [isExpanded, setIsExpanded] = useState(!isMobile);
  const { trackingCode } = useStepper();
  const navigate = useNavigate();

  const staffBtnRef = useRef();

  const handleUserEvent = (element) =>
    userTrackingMutation({
      variables: {
        ...trackingDetails,
        field_name:
          element?.current?.textContent || "Explore your other staff benefits",
        field_value: element?.current?.value?.toString() || "Clicked",
        avc_track_code: trackingCode,
      },
    });

  useEffect(() => {
    const handleScroll = () => {
      if (isMobile && isExpanded) {
        setIsExpanded(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isExpanded]);

  useEffect(() => {
    if (!isMobile) {
      setIsExpanded(true);
    } else {
      setIsExpanded(false);
    }
  }, [isMobile]);

  return (
    <Button
      ref={staffBtnRef}
      className="staffBenefitsButton"
      aria-label="Staff Benefits Button"
      data-type="Staff Benefits"
      onClick={() => {
        if (!isExpanded) {
          setIsExpanded(true);
          return;
        }
        handleUserEvent(staffBtnRef);
        navigate("/staff_benefits");
      }}
    >
      <Box
        component="img"
        src={vivupLogo}
        alt="staff-benefits"
        className="vivup-icon"
      />
      {isExpanded ? (
        <Typography className="font-elza content">
          Explore your other staff benefits
        </Typography>
      ) : null}
    </Button>
  );
};

StaffBenefitsButton.propTypes = {
  trackingDetails: PropTypes.object,
};

export default StaffBenefitsButton;
